// src/auth/usePermission.ts
// RM-14: hook مرکزی برای بررسی مجوز در UI.
// هر کامپوننتی که دکمهای باید hide/show کند از این hook استفاده میکند.
// این hook هرگز به سرور call نمیکند — فقط از state لاگینشده میخواند.

import { useAuthStore } from "@/auth/authStore";

/**
 * بررسی میکند آیا کاربر فعلی permission مشخصی دارد یا نه.
 *
 * استفاده:
 *   const canCreate = usePermission("inventory.manage");
 *   {canCreate && <button>ایجاد متریال</button>}
 *
 * @param code - کد permission به فرمت "domain.suffix"
 *               suffix های معتبر: view | manage
 *               domain های معتبر: inventory | production | quality |
 *                                  workflow | marketplace | forms | organization
 */
export function usePermission(code: string): boolean {
  const user = useAuthStore((s) => s.user);

  if (!user) return false;

  return user.permissions.includes(code);
}

/**
 * چک چند permission بهصورت همزمان.
 * true برمیگرداند اگر کاربر همهی آنها را داشته باشد (AND منطقی).
 *
 * استفاده:
 *   const canManage = usePermissions(["inventory.manage", "production.view"]);
 */
export function usePermissions(codes: string[]): boolean {
  const user = useAuthStore((s) => s.user);

  if (!user) return false;

  return codes.every((code) => user.permissions.includes(code));
}

/**
 * چک هر یک از چند permission (OR منطقی).
 * true برمیگرداند اگر کاربر حداقل یکی را داشته باشد.
 */
export function useAnyPermission(codes: string[]): boolean {
  const user = useAuthStore((s) => s.user);

  if (!user) return false;

  return codes.some((code) => user.permissions.includes(code));
}
